import { useLocation } from 'react-router-dom';
import { useGallery } from '../../context/GalleryContext';

// The slug path the nav should highlight for the current URL. Gallery/section routes
// highlight themselves; a viewing-room route (/section/.../artworkSlug) highlights its
// parent section.
export const useActiveSectionPath = (): string[] => {
    const { pathname } = useLocation();
    const { getSection } = useGallery();
    const slugPath = pathname.split('/').filter(Boolean);

    if (getSection(slugPath)) return slugPath;
    const parent = slugPath.slice(0, -1);
    if (parent.length && getSection(parent)) return parent;
    return slugPath;
};
